module.exports = {
	"articleTitle1": "West Quad renovations feature new study and cultural spaces ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "West Quadrangle",
	"articleLink1": "https://www.michigandaily.com/section/news/west-quad-renovations-feature-new-study-and-cultural-spaces",
	"articleLink2": "https://www.michigandaily.com/section/news/west-quad-best-quad",
	"articleSnippet1": "Aug 20, 2015 ... After closing last year for renovations, an updated West Quad will reopen this fall \nas home to 1,100 University students. As the most recent dorm ...",
	"articleSnippet2": "Sep 16, 2015 ... Shuttered for renovations over the last year, the West Quadrangle Residence \nHall held an official reopening ceremony Wednesday afternoon.",
	"totalMisc": 1,
	"articleTitle2": "West Quad ribbon cutting celebrates dorm's opening ",
	"address": "541 Thompson St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/ara.NEW_.Westquad.08.20.15.0658.jpg?itok=FL9FWpqq",
			"author": "Amanda Allen",
			"caption": "The main concourse on the first floor of West Quad."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/ara.NEW_.Westquad.08.20.15.0686.jpg?itok=W4PPHYbL",
			"author": "Amanda Allen",
			"caption": "The Community Learning Center of West Quad."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/150916/dso.NEW_.WestQuadOpening.09.16.15.083.jpg?itok=y9zyCIpB",
			"author": "David Song",
			"caption": "E. Royster Harper, vice president of student life, LSA seniors Jake Davidson and Amanda Champagne, President Mark Schlissel, and Dr. Marilyn De LaRoche cut the commemorative opening ceremony ribbon at West Quad on Wednesday."
		}
	],
	"position": {
		"lat": 42.275164,
		"lng": -83.74289
	},
	"tips": [
		{
			"text": "There are tons of good study spaces in West Quad. The CLC is probably my favorite.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"housing": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/westquad.json
// module id = 1002
// module chunks = 0